export const preparePositionString = string => {
  return typeof string === 'string' ? string.replace(/_/g, ' ') : null;
};
